import type { ComponentChildren } from "preact"

// The standalone top bar. It only lays out three groups — a left group, a
// Chrome-style dead-centered group, and a right group — and renders whatever
// each viewer hands it: the host's verbatim action buttons (download, 3D
// switch) on the right, the viewer's own controls (its pager, zoom, guides /
// camera presets) in the center and left. It knows nothing about pages,
// cameras, or zoom itself.
export function ViewerHeader({
  center,
  corner,
  left,
  right,
}: {
  center?: ComponentChildren
  // For a header over a rail (see ViewerSidebar): the square where the two
  // meet, its border carrying the rail's own up to the top and its button
  // padded like the rail (`px-2`) so it stacks over the rail's icons; the left
  // group starts past it.
  corner?: ComponentChildren
  left?: ComponentChildren
  right?: ComponentChildren
}) {
  return (
    // `data-slot`, the same hook the shadcn components expose: it paints no
    // background of its own, so a host that wants the header on a different
    // surface than the document under it has something to select. See
    // pdfview-app/src/theme.css.
    <header
      className={`relative flex h-12 shrink-0 items-center gap-2 border-b pr-4 ${corner ? "" : "pl-4"}`}
      data-slot="viewer-header"
    >
      {corner && (
        <div className="flex w-(--sidebar-width-icon) shrink-0 items-center self-stretch border-r px-2">
          {corner}
        </div>
      )}
      {left}
      <div className="absolute left-1/2 flex -translate-x-1/2 items-center gap-2">{center}</div>
      <div className="ml-auto flex items-center gap-2">{right}</div>
    </header>
  )
}
